import { Grid, Hidden, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { numberFormat } from "../../../helpers/numberFormat";

export const LPTitleData = ({ fund, url }) => {
  const { t } = useTranslation("global");
  const total = fund.total;
  const amount = fund.amount;
  const percentagePaid = fund.fund.percentagePaid || 0;
  const percentageDistributed = fund.fund.percentageDistributed || 0;
  const portfolioValue = fund.portfolioValue || 0;

  return (
    <Hidden smDown>
      <Stack width="100%" minWidth="315px" gap={0.1}>
        <Typography color="primary" variant="body1" sx={{ fontWeight: "bold" }}>
          "{fund.fund.name}"
        </Typography>
        <Grid container sx={{ alignItems: "center" }}>
          <Grid item xs={4} padding="0 5px">
            <Typography
              color="primary"
              variant="body1"
              sx={{ fontWeight: "bold" }}
            >
              {t("latentIvestments.commitment")}
            </Typography>
          </Grid>
          <Grid item xs={4} padding="0 5px">
            <Typography
              color="primary"
              variant="body1"
              sx={{ fontWeight: "bold" }}
              textAlign="center"
            >
              {t("latentIvestments.fund")}
            </Typography>
          </Grid>
          <Grid item xs={4} padding="0 5px">
            <Typography
              color="primary"
              variant="body1"
              sx={{ fontWeight: "bold" }}
              textAlign="center"
            >
              "{fund.whoInvest}"
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={4} padding="0 5px">
            <Typography color="primary" variant="body2">
              {t("latentIvestments.amountCommitted")}
            </Typography>
          </Grid>
          <Grid item xs={4} padding="0 5px">
            <Typography color="secondary" variant="body2" textAlign="center">
              {numberFormat(total)}
            </Typography>
          </Grid>
          <Grid item xs={4} padding="0 5px">
            <Typography color="secondary" variant="body2" textAlign="center">
              {numberFormat(amount)}
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={4} padding="0 5px">
            <Typography color="primary" variant="body2">
              {t("latentIvestments.participationFund")}
            </Typography>
          </Grid>
          <Grid item xs={4} padding="0 5px">
            <Typography color="secondary" variant="body2" textAlign="center">
              100%
            </Typography>
          </Grid>
          <Grid item xs={4} padding="0 5px">
            <Typography color="secondary" variant="body2" textAlign="center">
              {((amount * 100) / total).toFixed(2)}%
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={4} padding="0 5px">
            <Typography color="primary" variant="body2">
              {t("latentIvestments.percentage")}
            </Typography>
          </Grid>
          <Grid item xs={4} padding="0 5px">
            <Typography color="secondary" variant="body2" textAlign="center">
              {percentagePaid}%
            </Typography>
          </Grid>
          <Grid item xs={4} padding="0 5px">
            <Typography color="secondary" variant="body2" textAlign="center">
              {percentagePaid}%
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={4} padding="0 5px">
            <Typography color="primary" variant="body2">
              {t("latentIvestments.amountOfPaid")}
            </Typography>
          </Grid>
          <Grid item xs={4} padding="0 5px">
            <Typography color="secondary" variant="body2" textAlign="center">
              {numberFormat(total * (percentagePaid / 100))}
            </Typography>
          </Grid>
          <Grid item xs={4} padding="0 5px">
            <Typography color="secondary" variant="body2" textAlign="center">
              {numberFormat(amount * (percentagePaid / 100))}
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={4} padding="0 5px">
            <Typography color="primary" variant="body2">
              {t("latentIvestments.percentageDistributed")}
            </Typography>
          </Grid>
          <Grid item xs={4} padding="0 5px">
            <Typography color="secondary" variant="body2" textAlign="center">
              {Number(percentageDistributed).toLocaleString("es-ES", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}%
            </Typography>
          </Grid>
          <Grid item xs={4} padding="0 5px">
            <Typography color="secondary" variant="body2" textAlign="center">
              {Number(percentageDistributed).toLocaleString("es-ES", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}%
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={4} padding="0 5px">
            <Typography color="primary" variant="body2">
              {t("latentIvestments.amountDistributed")}
            </Typography>
          </Grid>
          <Grid item xs={4} padding="0 5px">
            <Typography color="secondary" variant="body2" textAlign="center">
              {numberFormat(total * (percentageDistributed / 100))}
            </Typography>
          </Grid>
          <Grid item xs={4} padding="0 5px">
            <Typography color="secondary" variant="body2" textAlign="center">
              {numberFormat(amount * (percentageDistributed / 100))}
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={4} padding="0 5px">
            <Typography color="primary" variant="body2">
              {t("latentIvestments.dpi")}
            </Typography>
          </Grid>
          <Grid item xs={4} padding="0 5px">
            <Typography color="secondary" variant="body2" textAlign="center">
              {percentagePaid ? (percentageDistributed / percentagePaid).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " x" : "0,00 x"}
            </Typography>
          </Grid>
          <Grid item xs={4} padding="0 5px">
            <Typography color="secondary" variant="body2" textAlign="center">
              {percentagePaid ? (percentageDistributed / percentagePaid).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " x" : "0,00 x"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={4} padding="0 5px">
            <Typography color="primary" variant="body2">
              {t("latentIvestments.rvpi")}
            </Typography>
          </Grid>
          <Grid item xs={4} padding="0 5px">
            <Typography color="secondary" variant="body2" textAlign="center">
              {(total * (percentagePaid / 100)) ? (portfolioValue / (total * (percentagePaid / 100))).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " x" : "0,00 x"}
            </Typography>
          </Grid>
          <Grid item xs={4} padding="0 5px">
            <Typography color="secondary" variant="body2" textAlign="center">
              {(total * (percentagePaid / 100)) ? (portfolioValue / (total * (percentagePaid / 100))).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " x" : "0,00 x"}
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={4} padding="0 5px">
            <Typography color="primary" variant="body2">
              {t("latentIvestments.tvpi")}
            </Typography>
          </Grid>
          <Grid item xs={4} padding="0 5px">
            <Typography color="secondary" variant="body2" textAlign="center">
              {(() => {
                const dpi = percentagePaid ? (percentageDistributed / percentagePaid) : 0;
                const rvpi = (total * (percentagePaid / 100)) ? (portfolioValue / (total * (percentagePaid / 100))) : 0;
                return (dpi + rvpi).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " x";
              })()}
            </Typography>
          </Grid>
          <Grid item xs={4} padding="0 5px">
            <Typography color="secondary" variant="body2" textAlign="center">
              {(() => {
                const dpi = percentagePaid ? (percentageDistributed / percentagePaid) : 0;
                const rvpi = (total * (percentagePaid / 100)) ? (portfolioValue / (total * (percentagePaid / 100))) : 0;
                return (dpi + rvpi).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " x";
              })()}
            </Typography>
          </Grid>
        </Grid>
        {url?.urlVideo && (
          <Stack direction="row" gap={2} padding="0 5px">
            <Typography color="primary" variant="body2">
              {t("latentIvestments.fundURL")}
            </Typography>
            <Typography color="secondary" variant="body2" textAlign="center">
              {" "}
              <a
                style={{ color: "#EA7F22" }}
                href={url.urlVideo}
                target="_blank"
                rel="noreferrer"
              >
                {t("link.link")}
              </a>
            </Typography>
          </Stack>
        )}
      </Stack>
    </Hidden>
  );
};
